export function unreachable(_x: never) {
  console.error('Not handled value', _x);
  return new Error('Unreachable code reached');
}
